import React, { useContext } from "react";
import { Button, Tooltip, Typography } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import CommonLayout from "../../Layout/CustomLayout";
import DoctorLayout from "../../Layout/DoctorLayout/index";
import PatientTypeContextProvider from "../../Layout/DoctorLayout/PatientTypeContextProvider";
import OrgTabs from "../OrgTabs";
import textStyles from "../../../styles/Custom/Typography.module.css";
import styles from "../orgSettings.module.css";
import { UserContext } from "../../../context/UserContext";
import { getCookie } from "../../../helpers/localStorage";
import { FacilityID, Role } from "../../../constants/defaultKeys";
import { getRoleDashboardPath } from "../../../helpers/auth/helper";
import useIsMobile from "../../../hooks/useIsMobile";

const ORG_LAYOUT_ROLES = new Set([
  "Organization_Owner",
  "Organization_Admin",
  "Facility_Admin",
  "Receptionist",
]);

const OrgBackHeader = ({ showTabs = false }) => {
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const facilityId =
    Number(getCookie(FacilityID)) || userDetails?.currFacility;
  const roleObj = userDetails?.activeOrg?.roles?.find(
    (r) => r.role === defaultRole && r.facility_id === Number(facilityId)
  );

  const goHome = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(getRoleDashboardPath(defaultRole, roleObj), { replace: true });
    }
  };

  return (
    <div className={styles.orgHeader}>
      <Tooltip title="Back">
        <Button
          type="text"
          shape="circle"
          icon={<LeftOutlined />}
          onClick={goHome}
          className={styles.orgBackBtn}
        />
      </Tooltip>
      <Typography className={`${textStyles.h6} ${styles.orgHeaderTitle}`}>
        Organisation Settings
      </Typography>
      {showTabs && <OrgTabs />}
    </div>
  );
};

const OrgTabPageShell = ({ sideContent, footer, header, children }) => {
  const { userDetails } = useContext(UserContext);
  const isMobile = useIsMobile();
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const useCommonLayout = ORG_LAYOUT_ROLES.has(defaultRole);
  const Layout = useCommonLayout ? CommonLayout : DoctorLayout;

  const resolvedHeader =
    header ??
    (isMobile ? (
      useCommonLayout ? (
        <Typography className={textStyles.h6}>Organisation Settings</Typography>
      ) : (
        true
      )
    ) : (
      <OrgBackHeader showTabs />
    ));

  return (
    <PatientTypeContextProvider>
      <Layout
        sideContent={sideContent}
        header={resolvedHeader}
        footer={footer}
        {...(!useCommonLayout ? { headerExtra: false } : {})}
      >
        {isMobile && (
          <div className={styles.orgTabsMobileBar}>
            <OrgTabs />
          </div>
        )}
        {children}
      </Layout>
    </PatientTypeContextProvider>
  );
};

export default OrgTabPageShell;
